import { Box, Switch } from "@mui/material";

export type Labels = [string, string];

interface SwitchLabelProps {
  labels?: Labels;
  onChange?: () => void;
  value: boolean;
  dataTestId?: string;
  disabled?: boolean;
}

export function SwitchWithLabel({
  onChange,
  value,
  dataTestId,
  disabled,
  labels = ["No", "Yes"],
  ...other
}: SwitchLabelProps) {
  // Box is added due to zIndex styles, which broke default behaviour of Switch, but it's needed due to style guide
  return (
    <Box onClick={onChange} role="switch" {...other}>
      <Switch
        sx={(theme) => ({
          width: "104px",
          height: "40px",
          padding: "0px",
          cursor: "pointer",
          position: "relative",
          "&:after, &:before": {
            fontSize: "16px",
            fontWeight: 400,
          },
          "&:after": {
            position: "absolute",
            zIndex: 1,
            color: theme.palette.info.main,
            content: `"${labels[0]}"`,
            left: "17px",
            top: "9px",
          },
          "&:before": {
            position: "absolute",
            zIndex: 1,
            color: value ? theme.palette.common.white : theme.palette.info.main,
            content: `"${labels[1]}"`,
            right: "15px",
            top: "9px",
          },
          "& .MuiSwitch-switchBase": {
            color: "action.disabled",
            padding: "1px",
            zIndex: 0,
            "&.Mui-checked": {
              "& + .MuiSwitch-track": {
                borderColor: "#DFDFDF",
                backgroundColor: "transparent",
              },
            },
          },
          "& .MuiSwitch-thumb": {
            width: "52px",
            height: "34px",
            borderRadius: "30px",
            margin: "2px",
          },
          "& .MuiSwitch-track": {
            backgroundColor: "transparent",
            borderRadius: "30px",
            opacity: "1 !important",
          },
          "& .Mui-checked": {
            color: `${theme.palette.primary.main} !important`,
            transform: "translateX(46px) !important",
          },
        })}
        disabled={disabled}
        checked={value}
        data-testid={dataTestId}
        inputProps={{ "aria-label": "switch" }}
      />
    </Box>
  );
}
